module.exports = __webpack_public_path__ + "static/scale-model-of-ulrich-museum-of-art-in-wichita-kansas-df20d56467225d1d91f64bdcbdb9c7a2.png";